import { Eye, Monitor, Redo2, RotateCcw, Save, Smartphone, Tablet, Undo2, Upload, X } from "lucide-react";
import { useBuilder } from "./context";

const btn = "flex h-8 items-center gap-1.5 px-2.5 text-neutral-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-30";

export default function TopBar() {
  const b = useBuilder();
  return (
    <div className="flex h-12 shrink-0 items-center justify-between border-b border-white/10 bg-[#141416] px-3" data-builder-ui data-testid="builder-topbar">
      <div className="flex items-center gap-3">
        <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-white">Builder</span>
        <span className="text-[10px] uppercase tracking-[0.2em] text-neutral-500">Sergio Chavez — Landing</span>
      </div>

      <div className="flex items-center border border-white/10" data-testid="device-switcher">
        {[["desktop", Monitor], ["tablet", Tablet], ["mobile", Smartphone]].map(([d, Icon]) => (
          <button
            key={d}
            onClick={() => b.setDevice(d)}
            data-testid={`device-${d}`}
            title={d}
            className={`flex h-8 w-10 items-center justify-center transition-colors ${b.device === d ? "bg-white text-black" : "text-neutral-400 hover:text-white"}`}
          >
            <Icon className="h-4 w-4" />
          </button>
        ))}
      </div>

      <div className="flex items-center gap-1">
        <button onClick={b.undo} disabled={!b.canUndo} className={btn} title="Undo (Cmd+Z)" data-testid="builder-undo"><Undo2 className="h-4 w-4" /></button>
        <button onClick={b.redo} disabled={!b.canRedo} className={btn} title="Redo (Cmd+Shift+Z)" data-testid="builder-redo"><Redo2 className="h-4 w-4" /></button>
        <button onClick={b.resetAll} className={btn} title="Discard all edits" data-testid="builder-reset"><RotateCcw className="h-4 w-4" /></button>
        <span className="mx-1 h-4 w-px bg-white/10" />
        <button onClick={() => b.setPreview(!b.preview)} className={btn} data-testid="builder-preview-toggle">
          <Eye className="h-4 w-4" />{b.preview ? "Edit" : "Preview"}
        </button>
        <button onClick={b.save} className={btn} data-testid="builder-save">
          <Save className="h-4 w-4" />{b.saving === "saving" ? "Saving…" : "Save draft"}
        </button>
        <button
          onClick={b.publish}
          data-testid="builder-publish"
          className="flex h-8 items-center gap-1.5 bg-white px-3 text-xs font-semibold uppercase tracking-wider text-black transition-colors hover:bg-neutral-300"
        >
          <Upload className="h-3.5 w-3.5" />{b.saving === "publishing" ? "Publishing…" : "Publish"}
        </button>
        <button onClick={() => b.setShowHelp(true)} className={btn} title="Keyboard shortcuts (?)" data-testid="builder-help"><span className="px-1 text-xs font-bold">?</span></button>
        <button onClick={b.logout} className={btn} title="Sign out" data-testid="builder-logout"><span className="px-1 text-[10px] font-semibold uppercase tracking-wider">Exit&nbsp;·&nbsp;Sign&nbsp;out</span></button>
        <a href="/" className={btn} title="Back to site" data-testid="builder-exit"><X className="h-4 w-4" /></a>
      </div>
    </div>
  );
}
